/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import apiConnect from '../../api/apiConnect'
import {useParams} from 'react-router-dom'
import {InformationTab} from './component/InformationTab'
import {AdvanceTab} from './component/AdvanceTab'
import {SendCommandTab} from './component/SendCommandTab'
import {SettingTab} from './component/SettingTab'
import {RealtimeDataTab} from './component/RealtimeDataTab'
import {DataRecorded} from './component/DataRecorded'
import {AlarmTab} from './component/AlarmTab'
import {useThemeMode} from '../../../_metronic/partials'
import {useUser} from '../../modules/newauth/UserContext'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {VBox} from './component/VBox'
import {useLocation} from 'react-router-dom'

const DeviceDetail = () => {
  const [deviceData, setDeviceData] = useState([])
  const deviceId = useParams().deviceId
  const [trigger, setTrigger] = useState(false)
  const {mode} = useThemeMode()
  const {user} = useUser()
  const navigate = useNavigate()
  const location = useLocation()

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/devices/by-device-id/${deviceId}`)

        // Check Device Owner
        if (user?.role == 'user') {
          if (user?.userIdMalin1 !== response.data?.owner) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'You are not authorized to view this device.',
            }).then(() => {
              navigate(`/dashboard`)
            })
          }
        }

        // Check Device ID
        if (response?.data?.status == 'error' && response?.data?.text == 'No such document!') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Device not found!',
          }).then(() => {
            navigate(`/dashboard`)
          })
        }

        setDeviceData(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [trigger])

  useEffect(() => {
    if (location.hash === '#parameter') {
      setActiveIndex(0)
    } else if (location.hash === '#alarm') {
      setActiveIndex(1)
    } else if (location.hash === '#vbox') {
      setActiveIndex(2)
    } else if (location.hash === '#send-command') {
      // setActiveIndex(4)
    } else if (location.hash === '#setting') {
      setActiveIndex(4)
    }
  }, [location.hash])

  // ดึง activeIndex จาก localStorage ถ้ามี ไม่งั้นใช้ 0
  const [activeIndex, setActiveIndex] = useState(() => {
    const savedIndex = localStorage.getItem('deviceDetailActiveIndex')
    return savedIndex !== null ? Number(savedIndex) : 0
  })

  // ดึง activeIndex จาก localStorage ถ้ามี ไม่งั้นใช้ 0
  const [activeSettingIndex, setActiveSettingIndex] = useState(() => {
    const savedIndex = localStorage.getItem('deviceDetailActiveSettingIndex')
    return savedIndex !== null ? Number(savedIndex) : 0
  })

  // เซฟ activeIndex ลง localStorage ทุกครั้งที่เปลี่ยน
  useEffect(() => {
    localStorage.setItem('deviceDetailActiveIndex', activeIndex.toString())
  }, [activeIndex])

  // เซฟ activeSettingIndex ลง localStorage ทุกครั้งที่เปลี่ยน
  useEffect(() => {
    localStorage.setItem('deviceDetailActiveSettingIndex', activeSettingIndex.toString())
  }, [activeSettingIndex])

  const tabs = [
    {icon: 'fa-server', title: 'Parameter', active: true},
    {icon: 'fa-bell', title: 'Alarm'},
    // {icon: 'fa-server', title: 'Parameter'},
    {icon: 'fa-link', title: 'V-Box'},
    {icon: 'fa-terminal', title: 'Send Command'},
    {icon: 'fa-gear', title: 'Setting'},
  ]

  return (
    <>
      <div className='d-flex flex-wrap flex-stack mb-6'>
        <h3 className='fw-bolder'>
          Device : {deviceData?.name}{' '}
          {deviceData?.premium ? (
            <span className='badge badge-info'>Premium</span>
          ) : (
            <span className='badge badge-light'>Standard</span>
          )}
        </h3>

        <div className='d-flex my-2'>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={'/dashboard'} className='pe-3'>
                Home
              </Link>
            </li>

            <li className='breadcrumb-item px-3 text-muted'>{deviceData?.name}</li>
          </ol>
        </div>
      </div>

      {isMobile ? (
        <div
          className='d-flex overflow-auto flex-nowrap w-100 mb-4'
          style={{border: '1px solid black'}}
        >
          {tabs.map((tab, index) => (
            <div
              key={index}
              onClick={() => index !== 3 && setActiveIndex(index)}
              className='d-flex flex-column align-items-center justify-content-center px-4 py-3'
              style={{
                minWidth: 100,
                backgroundColor:
                  mode === 'dark'
                    ? activeIndex === index
                      ? '#2e2e3a'
                      : '#1e1e2d'
                    : activeIndex === index
                    ? 'black'
                    : 'white',
                color:
                  mode === 'dark'
                    ? activeIndex === index
                      ? 'white'
                      : '#ccc'
                    : activeIndex === index
                    ? 'white'
                    : 'black',
                cursor: index === 3 ? 'not-allowed' : 'pointer',
                opacity: index === 3 ? 0.5 : 1,
                flex: '0 0 auto',
              }}
            >
              <i className={`fas ${tab.icon} mb-1`} style={{fontSize: '1.2rem'}}></i>
              <span className='fs-7 text-center'>{tab.title}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className='d-flex w-100 flex-wrap mt-8 mb-8' style={{border: '1px solid #3e97ff'}}>
          {tabs.map((tab, index) => (
            <div
              key={index}
              onClick={() => {
                if (index !== 3) {
                  setActiveIndex(index)
                }
              }}
              className='d-flex align-items-center justify-content-center px-4 py-6 flex-grow-1'
              style={{
                minWidth: '120px',
                height: '50px',
                backgroundColor:
                  mode === 'dark'
                    ? activeIndex === index
                      ? '#2e2e3a'
                      : '#1e1e2d'
                    : activeIndex === index
                    ? '#3e97ff'
                    : 'white',
                color:
                  mode === 'dark'
                    ? activeIndex === index
                      ? 'white'
                      : '#cccccc'
                    : activeIndex === index
                    ? 'white'
                    : 'black',
                cursor: index === 3 ? 'not-allowed' : 'pointer',
                borderRight: index !== tabs.length - 1 ? '1px solid #3e97ff' : 'none',
                opacity: index === 3 ? 0.5 : 1,
              }}
            >
              <i
                className={`fas ${tab.icon} me-3 fs-2`}
                style={{
                  color:
                    mode === 'dark'
                      ? activeIndex === index
                        ? 'white'
                        : '#aaaaaa'
                      : activeIndex === index
                      ? 'white'
                      : '#3e97ff',
                }}
              ></i>
              <span className='fw-bold fs-6'>{tab.title}</span>
            </div>
          ))}
        </div>
      )}

      {activeIndex === 0 && <RealtimeDataTab isMobile={isMobile} deviceData={deviceData} />}

      {activeIndex === 1 && <AlarmTab deviceData={deviceData} />}

      {activeIndex === 2 && <VBox />}

      {activeIndex === 3 && (
        <div className='card mb-5 mb-xl-10'>
          <div className='card-body border-top py-3'>
            <SendCommandTab deviceData={deviceData} />
          </div>
        </div>
      )}

      {activeIndex === 4 && (
        <div className='card mb-5 mb-xl-10'>
          <div className='card-body border-top py-3'>
            <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x fs-5 mb-10'>
              <li className='nav-item me-4' style={{minWidth: '120px'}}>
                <a
                  className='nav-link fw-semibold fs-6 fs-md-4 text-gray-700'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_information'
                  onClick={() => {
                    setActiveSettingIndex(0)
                    localStorage.setItem('deviceDetailActiveSettingIndex', '0')
                  }}
                >
                  Information
                </a>
              </li>
              <li className='nav-item me-4' style={{minWidth: '120px'}}>
                <a
                  className='nav-link fw-semibold fs-6 fs-md-4 text-gray-700'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_key'
                  onClick={() => {
                    setActiveSettingIndex(1)
                    localStorage.setItem('deviceDetailActiveSettingIndex', '1')
                  }}
                >
                  Key
                </a>
              </li>
              <li className='nav-item me-4' style={{minWidth: '150px'}}>
                <a
                  className='nav-link fw-semibold fs-6 fs-md-4 text-gray-700'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_data_recorded'
                  onClick={() => {
                    setActiveSettingIndex(2)
                    localStorage.setItem('deviceDetailActiveSettingIndex', '2')
                  }}
                >
                  Data Recorded
                </a>
              </li>
              <li className='nav-item' style={{minWidth: '120px'}}>
                <a
                  className='nav-link fw-semibold fs-6 fs-md-4 text-gray-700'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_setting'
                  onClick={() => {
                    setActiveSettingIndex(3)
                    localStorage.setItem('deviceDetailActiveSettingIndex', '3')
                  }}
                >
                  Setting
                </a>
              </li>
            </ul>
            <div className='tab-content' id='myTabContent'>
              {activeSettingIndex === 0 && (
                <InformationTab deviceData={deviceData} trigger={trigger} setTrigger={setTrigger} />
              )}
              {activeSettingIndex === 1 && <AdvanceTab deviceData={deviceData} />}
              {activeSettingIndex === 2 && <DataRecorded />}
              {activeSettingIndex === 3 && <SettingTab deviceData={deviceData} />}

              {/* <div
                className='tab-pane fade show active'
                id='kt_tab_pane_information'
                role='tabpanel'
              >
                <InformationTab deviceData={deviceData} trigger={trigger} setTrigger={setTrigger} />
              </div>
              <div className='tab-pane fade' id='kt_tab_pane_key' role='tabpanel'>
                <AdvanceTab deviceData={deviceData} />
              </div>
              <div className='tab-pane fade' id='kt_tab_pane_data_recorded' role='tabpanel'>
                <DataRecorded />
              </div>
              <div className='tab-pane fade' id='kt_tab_pane_setting' role='tabpanel'>
                <SettingTab deviceData={deviceData} />
              </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export {DeviceDetail}
